import { render } from "./Testimonial.vue?vue&type=template&id=40463e2d&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=40463e2d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40463e2d"]])

export default __exports__